import React, { useState, useEffect, useRef } from 'react';

const OptimizedVideo = ({
  src,
  poster,
  className,
  width,
  height,
  autoPlay = true,
  loop = true,
  muted = true,
  playsInline = true,
  controls = false,
  preload = 'metadata',
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.addEventListener('loadeddata', () => {
        setIsLoaded(true);
      });
    }

    return () => {
      if (videoRef.current) {
        videoRef.current.removeEventListener('loadeddata', () => {
          setIsLoaded(true);
        });
      }
    };
  }, []);

  return (
    <div
      className={`optimized-video-container ${className || ''}`}
      style={{
        position: 'relative',
        width: width || '100%',
        height: height || 'auto',
        overflow: 'hidden',
        backgroundColor: '#000'
      }}
    >
      {!isLoaded && poster && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${poster})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: 1
          }}
        />
      )}
      
      <video
        ref={videoRef}
        className="optimized-video"
        autoPlay={autoPlay}
        loop={loop}
        muted={muted}
        playsInline={playsInline}
        controls={controls}
        preload={preload}
        poster={poster}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: isLoaded ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
          zIndex: 2
        }}
        {...props}
      >
        <source src={src} type={`video/${src.split('.').pop()}`} />
        Votre navigateur ne prend pas en charge la lecture de vidéos.
      </video>
      
      {/* Indicateur de chargement */}
      {!isLoaded && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 3
          }}
        >
          <div className="loading-spinner"></div>
        </div>
      )}
    </div>
  );
};

export default OptimizedVideo; 